import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { NumericFormat } from '@blade/std-lib'
import { Tooltip, WarningTriangleIcon } from '@blade/ui-kit'

import type { PairModel } from '../../atoms'

type PairAuditBadgeProps = {
  pair: PairModel
}

export const PairAuditBadge: React.FC<PairAuditBadgeProps> = memo(
  ({ pair }) => {
    const [audit] = useAtom(pair.audit)
    const isFreezable = audit.checks.isFreezable.value
    const isMintable = audit.checks.isMintable.value
    const lpNotBurned = audit.checks.lpBurned.status !== 'Safe'

    if (!isFreezable && !isMintable && !lpNotBurned) {
      return undefined
    }

    return (
      <Tooltip content={<TooltipContent pair={pair} />}>
        <Root>
          <WarningTriangleIcon size={16} color="var(--error-9)" />
        </Root>
      </Tooltip>
    )
  },
)

const Root = styled.div`
  pointer-events: auto;
  display: grid;
`

const TooltipContent: React.FC<{ pair: PairModel }> = ({ pair }) => {
  const { t } = useTranslation()
  const [audit] = useAtom(pair.audit)
  const isFreezable = audit.checks.isFreezable.value
  const isMintable = audit.checks.isMintable.value
  const lpNotBurned = audit.checks.lpBurned.status !== 'Safe'
  const lpBurnedPercent = audit.checks.lpBurned.percent

  return (
    <TooltipRoot>
      {isFreezable && (
        <Item>{t('trading.audit.is-freezable.warning-tooltip')}</Item>
      )}
      {isMintable && (
        <Item>{t('trading.audit.is-mintable.warning-tooltip')}</Item>
      )}
      {lpNotBurned && (
        <Item>
          {t('trading.audit.lp-burned.warning-tooltip', {
            burnedPercent: NumericFormat.formatPreset(
              lpBurnedPercent,
              'percents',
            ),
          })}
        </Item>
      )}
    </TooltipRoot>
  )
}

const TooltipRoot = styled.div``
const Item = styled.div`
  color: var(--error-11);
`
